let language = {
    DETAIL_SNAPSHOP_TITLE: "安装",
    DETAIL_SNAPSHOP_DESCRIPTION_1: "如果您还没有电子商店，请使用以下命令创建 SnapShop ",
    DETAIL_SNAPSHOP_DESCRIPTION_2: " 开始销售我们的定制按需印刷产品。它是免费的，可以在一小时内完成设置。如果您在设置过程中遇到任何问题，请联系我们",
    DETAIL_SNAPSHOP_NAME: "快照店",
    DETAIL_SNAPSHOP_NAME_GROUP: "快照商店",
}

export { language }